import React from "react";

import { GetStaticProps } from "next";
import {
  ATypeBeneficiaryHead,
  ATypeCardView,
  BTypeBreadCrumb,
} from "goi_common";
import crematorium from "goi_common/src/constants/hwajang_detail.json";
import facilities from "goi_common/src/constants/facilities_detail.json";
import { parlorRegion } from "@/constants/parlorRegion";
import { Stack } from "@mui/material";
import Head from "next/head";

const { regionColor, targetSidos } = parlorRegion;

export const getStaticProps: GetStaticProps = async () => {
  const regionCrematoriums = crematorium.filter((p) =>
    targetSidos.includes(String(p.sido))
  );
  const regionPublicFacilities = facilities.filter(
    (f) => targetSidos.includes(f.sido) && f.is_public
  );
  const description =
    "기초생활수급자 혜택 2가지 정리 및 안내. 혜택 적용 가능한 화장장, 장지 시설 안내. 기초생활수급자(의료, 생계)라면 위의 2가지 혜택을 받을 수 있습니다. 만약 이해하기 어려운 점이 있거나 더 자세하게 알고 싶은 것이 있다면, 바로 상담을 진행하세요.";

  return {
    props: {
      regionCrematoriums,
      regionPublicFacilities,
      pageDescription: description,
      pageKeywords: `기초생활수급자 장례, 기초생활수급자 장례, 장제비, 장제급여, 기초생활수급자 장례 얼마`,
      pageOgTitle: `기초생활수급자 장례정보(대구경북) | 대구경북장례정보포털`,
      pageOgDescription: description,
      pageOgImage: "",
    },
  };
};

export default function index({
  regionCrematoriums,
  regionPublicFacilities,
  pageOgTitle,
}: {
  regionCrematoriums: Array<any>;
  regionPublicFacilities: Array<any>;
  pageOgTitle: string;
}) {
  const carouselItems = regionCrematoriums.map((res, i) => {
    return {
      "@type": "ListItem",
      name: `(비용안내) ${res.companyname}`,
      image: `${res.images[0].url}`,
      url: `https://dggb-portal.funeralblog.co.kr/funeral-places/${res.id}/`,
      position: i + 1,
    };
  });

  const carouselRichSearch =
    regionCrematoriums.length > 6
      ? {
          "@context": "http://schema.org",
          "@type": "ItemList",
          itemListElement: carouselItems,
        }
      : {};
  return (
    <>
      <Head>
        <title>{pageOgTitle}</title>
        {regionCrematoriums.length > 5 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(carouselRichSearch),
            }}
          />
        )}
      </Head>
      <BTypeBreadCrumb
        firstItem={{
          text: `대구 경북 기초생활수급자 장례헬프센터`,
          href: `/beneficiary/`,
          event: {
            domain: "dggb",
            path: "benef",
            trigger_and_target: "br_crumb_benef",
          },
        }}
        goiHomeEvent={{
          domain: "dggb",
          path: "benef",
          trigger_and_target: "br_crumb_goi_home",
        }}
      />

      <ATypeBeneficiaryHead
        titleSido="대구 · 경북"
        mainColor={regionColor}
        event={{
          domain: "dggb",
          path: "benef",
          trigger_and_target: "goi_call",
        }}
      />

      <Stack
        style={{ background: regionColor.c100 }}
        padding="40px 20px"
        marginBottom="40px"
        gap="8px"
      >
        <h3 className="button_16_sb">대구 · 경북 지역 화장장</h3>
        {regionCrematoriums.map((res) => (
          <ATypeCardView
            key={res.companyname}
            name={res.companyname}
            href={`/beneficiary/crematorium/${res.companyname}/`}
            descriptions={["기초생활수급자 무료"]}
            imgSrc={res.images[0] ? res.images[0].url : ""}
          />
        ))}
      </Stack>

      <Stack padding="40px 20px" marginBottom="40px" gap="8px">
        <h3 className="button_16_sb">대구 · 경북 지역 공설 장지</h3>
        {regionPublicFacilities.map((res) => (
          <ATypeCardView
            key={res.companyname}
            name={res.companyname}
            href={`/beneficiary/public-facility/${res.companyname}/`}
            // descriptions={["기초생활수급자 무료"]}
            descriptions={[""]}
            imgSrc={res.images[0] ? res.images[0].url : ""}
          />
        ))}
      </Stack>
    </>
  );
}
